import { motion } from "framer-motion";
import { Camera, ImageOff } from "lucide-react";
import foto_1 from "@/assets/gallery/foto_1.webp";
import foto_2 from "@/assets/gallery/foto_2.webp";
import foto_3 from "@/assets/gallery/foto_3.webp";
import foto_4 from "@/assets/gallery/foto_4.webp";
import foto_5 from "@/assets/gallery/foto_5.webp";
import foto_6 from "@/assets/gallery/foto_6.webp";
import foto_7 from "@/assets/gallery/foto_7.webp";
import foto_8 from "@/assets/gallery/foto_8.webp";


/**
 * Gallery page — placeholder grid.
 * Images will be replaced with real tournament photos provided by the client.
 */

const PHOTOS = [
  {
    id: 1,
    src: foto_1,
    label: "Ifoto1",
    height: "h-[420px]",
  },
  {
    id: 2,
    src: foto_2,
    label: "foto 2",
    height: "h-[460px]",
  },
  {
    id: 3,
    src: foto_3,
    label: "foto 3",
    height: "h-[340px]",
  },
  {
    id: 4,
    src: foto_4,
    label: "foto 4",
    height: "h-[340px]",
  },
  {
    id: 5,
    src: foto_5,
    label: "foto 5",
    height: "h-[340px]",
  },
  {
    id: 6,
    src: foto_6,
    label: "foto 6",
    height: "h-[340px]",
  },
  {
    id: 7,
    src: foto_7,
    label: "foto 7",
    height: "h-[340px]",
  },
  {
    id: 8,
    src: foto_8,
    label: "foto 8",
    height: "h-[340px]",
  },
];

export default function Gallery() {
  return (
    <div data-testid="page-gallery" className="text-white">
      <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="text-xs uppercase tracking-[0.3em] text-[#FF4500] font-bold"
        >
          / Archivio visivo
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-4 font-bebas uppercase leading-[0.85] text-6xl sm:text-7xl md:text-[10vw]"
        >
          La <span className="text-[#FF4500]">galleria</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-6 max-w-2xl text-[#A3A3A3] leading-relaxed"
        >
          Istantanee dalle edizioni passate, dietro le quinte, celebrazioni e
          momenti che hanno definito il torneo. Le foto ufficiali dell'edizione
          2026 verranno caricate qui.
        </motion.p>
      </section>

      <section
        data-testid="gallery-grid"
        className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24"
      >
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {PHOTOS.map((p, i) => (
            <motion.figure
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 6) * 0.05 }}
              className="mb-6 break-inside-avoid group relative overflow-hidden bg-[#0A0A0A] border border-[#2A2A2A] hover:border-[#FF4500] transition-colors duration-300"
              data-testid={`gallery-item-${p.id}`}
            >
            <div className={`relative ${p.height} w-full overflow-hidden`}>
              <img
              src={p.src}
              alt={p.label}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>  

              <figcaption className="flex items-center justify-between px-5 py-3 border-t border-[#2A2A2A] text-[10px] uppercase tracking-[0.25em] text-[#A3A3A3] font-bold">
                <span>BTR 3x3 · 2025</span>
                <span className="text-[#FF4500]">#{p.id}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>
    </div>
  );
}